import schemas from './schemas';
import store from '../../store';

export default class DBHandler {
  db;

  constructor(database) {
    if (!window.indexedDB) {
      throw "Your browser doesn't support IndexedDB.";
    }
    const request = window.indexedDB.open(database, schemas.version);

    request.onerror = (e) => {
      throw "There was an error creating database";
    };

    request.onsuccess = (e) => {
      this.db = request.result;
      store.dispatch("fillState").then(() => {
      });
    };

    request.onupgradeneeded = (e) => {
      this.db = e.target.result;
      Object.keys(schemas.objectStores).forEach((tableName) => {
        if (!this.db.objectStoreNames.contains(tableName)) {
          const config = schemas.objectStores[tableName];
          let storeResult = null;
          if (config.keyPath) {
            storeResult = this.db.createObjectStore(tableName, { keyPath: config.keyPath, autoIncrement: false });
            /*if (tableName == "PDV_Clientes") {
              storeResult.createIndex("indexed", ['Tenant', 'UpdatedAt']);
            }*/
            /*if (tableName == "BNK_LineasCredito") {
              storeResult.createIndex("indexed", ['Tenant', 'upat']);
            }*/
            /* if (tableName == "MBS_Membresias") {
              storeResult.createIndex("indexed", ['Tenant', 'Upat']);
            }*/
            /*if (tableName == "PDV_Modificadores") {
              if (!storeResult.indexNames.contains('indexed')) {
                storeResult.createIndex("indexed", ['Tenant', 'Upat']);
              }
            }*/
            /*if (tableName == "AYB_Contenedores") {
              if (!storeResult.indexNames.contains('indexed')) {
                storeResult.createIndex("indexed", ['upat', 'id']);
              }
            }*/
          } else if (config.autoIncrement) {
            storeResult = this.db.createObjectStore(tableName, { autoIncrement: true });
          } else {
            storeResult = this.db.createObjectStore(tableName);
          }

          if (config.indexes) {
            config.indexes.map((index) => {
              storeResult.createIndex(index.name, index.keyPath, { unique: index.unique });
            });
          }
        }
        // this.db.deleteObjectStore(tableName);
      });
    };
  }

  updateObjectsStore() {
    Object.keys(schemas.objectStores).forEach((tableName) => {
      if (!this.db.objectStoreNames.contains(tableName)) {
        if (schemas.objectStores[tableName].keyPath) {
          this.db.createObjectStore(tableName, { keyPath: schemas.objectStores[tableName].keyPath, autoIncrement: false });
        } else {
          this.db.createObjectStore(tableName, { autoIncrement: true });
        }
      }
    });
  }

  getInstance() {
    return this.db;
  }

  getRecord(table, key) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(table, "readwrite");
      const store = transaction.objectStore(table);
      const request = store.get(key);

      request.onerror = (e) => {
        reject(e);
      }

      request.onsuccess = (e) => {
        resolve(e.target.result);
      }
    });
  }

  getLastRecord(table, prop) {
    return new Promise((resolve, reject) => {

      let lowerBound = [localStorage.ParGolfTenant, 0];
      let upperBound = [localStorage.ParGolfTenant, new Date().valueOf()];
      let rango = IDBKeyRange.bound(lowerBound, upperBound)
      const transaction = this.db.transaction(table, "readwrite");
      /*Regresa solo los registros basados en el index Tenant de cada Tabla*/
      const store = transaction.objectStore(table).index("indexed");
      store.openCursor(rango, 'prev').onsuccess = function (e) {
        resolve(e.target.result);
      };
    });
  }

  getAllRecordsArr(table) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(table, "readwrite");
      /*Regresa solo los registros basados en el index Tenant de cada Tabla*/
      const store = transaction.objectStore(table).index("Tenant");
      const request = store.getAll(localStorage.ParGolfTenant);
      request.onerror = (e) => {
        reject(e);
      }
      request.onsuccess = (e) => {
        resolve(e.target.result);
      }
    });
  }

  getAllRecordsObj(table) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(table, "readwrite");
      const store = transaction.objectStore(table);
      const request = store.openCursor();
      const res = {};
      request.onerror = (e) => {
        reject(e);
      }
      request.onsuccess = (e) => {
        const cursor = e.target.result;

        try {
          if (cursor) {
            res[cursor.key] = cursor.value;
            cursor.continue();
          } else {
            resolve(res);
          }
        } catch (ex) {
          reject(e);
        }
      }
    });
  }

  addRecord(table, record) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(table, "readwrite");
      const store = transaction.objectStore(table);
      const request = store.add(record);

      request.onerror = (e) => {
        reject(e);
      }

      request.onsuccess = (e) => {
        resolve(e);
      }
    });
  }
  putRecords(table, records) {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(records) || records.length === 0) {
        reject("putRecords expects an array of records");
        return;
      }

      const transaction = this.db.transaction(table, "readwrite");
      const store = transaction.objectStore(table);
      let completed = 0;
      let hasError = false;

      transaction.onerror = (e) => {
        hasError = true;
        reject(e);
      }

      transaction.oncomplete = (e) => {
        if (!hasError) {
          resolve(e);
        }
      }

      // Insertar todos los registros en la misma transacción
      records.forEach((record) => {
        store.put(record);
      });
    });
  }
  putRecord(table, record) {
    if (table.startsWith('signIns')) {
      //(table,record)
    }
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(table, "readwrite");
      const store = transaction.objectStore(table);
      const request = store.put(record);

      request.onerror = (e) => {
        reject(e);
      }

      request.onsuccess = (e) => {
        resolve(e);
      }
    }).catch(err => { console.error("PERROR", table, record, err) }).then(val => val);
  }

  deleteRecord(table, key) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(table, "readwrite");
      const store = transaction.objectStore(table);
      const request = store.delete(key);

      request.onerror = (e) => {
        reject(e);
      }

      request.onsuccess = (e) => {
        resolve(e);
      }
    });
  }
  deleteRecords(table, keys) {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(keys) || keys.length === 0) {
        reject("deleteRecords expects an array of keys");
        return;
      }

      const transaction = this.db.transaction(table, "readwrite");
      const store = transaction.objectStore(table);
      let hasError = false;

      transaction.onerror = (e) => {
        hasError = true;
        reject(e);
      }

      transaction.oncomplete = (e) => {
        if (!hasError) {
          resolve(e);
        }
      }

      // Eliminar todos los registros en la misma transacción
      keys.forEach((key) => {
        store.delete(key);
      });
    });
  }
}
